import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type {
	PopupContentRuntimeProps,
	PopupContentQueries,
	PopupContentNestedEntryPoints,
	PopupContentExtraProps,
} from '../../../types/entrypoint';

type EntryPointParams = {};

type PopupContentComponent = EntryPointComponent<
	PopupContentQueries,
	PopupContentNestedEntryPoints,
	PopupContentRuntimeProps,
	PopupContentExtraProps
>;

export const popupContentEntryPoint: EntryPoint<PopupContentComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "@atlassian-universal-create_popup-content" */ '../PopupContent/PopupContent'
				).then((module) => ({ default: module.PopupContent as PopupContentComponent })),
			{
				moduleId: 'universal-create-popup-content',
			},
		),
		getPreloadProps: (_params: EntryPointParams) => ({
			queries: {},
			entryPoints: {},
			extraProps: {},
		}),
	});
